import qs from 'querystringify'
import remote from './remote'

const URL = {
    ADD: '/cms/newsletter',
    SEARCH: '/cms/newsletter',
    DELETE: '/cms/newsletter',
    UPDATE: '/cms/newsletter'
}

export default {
    newsletterAdd (noti, uploadProgressHandler) {
        return remote.request({
            url: remote.getUrl(URL.ADD),
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: noti,
            timeout: 3600000,
            onUploadProgress: uploadProgressHandler
        })
    },
    updateNewsletter (contentId, noti, uploadProgressHandler) {
        return remote.request({
            url: remote.getUrl(URL.UPDATE) + '/' + contentId,
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: noti,
            timeout: 3600000,
            onUploadProgress: uploadProgressHandler
        })
    },
    searchNewsletter (option) {
        let url = remote.getUrl(URL.SEARCH)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url
        })
    },
    searchNewsletterDetail (contentId) {
        return remote.request({
            url: remote.getUrl(URL.SEARCH) + '/' + contentId,
            timeout: 30000,
        })
    },
    removeNewsletter (contentId) {
        return remote.request({
            url: remote.getUrl(URL.DELETE),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(contentId) ? contentId : [contentId],
        })
    }
}
